<template>
  <v-navigation-drawer
    v-model="internalValue"
    fixed
    width="345px"
    temporary
    disable-resize-watcher
    disable-route-watcher
    touchless
  >
    <div class="pa-4">
      <div class="text-h4 text-uppercase mb-4">{{ $t('commons.filter') }}</div>

      <v-progress-circular
        v-if="loadingAggregations"
        indeterminate
        class="d-block ma-auto text-center"
        color="purple"
        :size="64"
      ></v-progress-circular>

      <product-listing-filter-container
        v-for="filter in availableFilters"
        :key="filter.id || filter.code"
        :value="filterValues[filter.code]"
        :filter="filter"
        class="mt-3"
        @input="$emit('input:filter', filter.code, $event)"
        @change="$emit('change', $event)"
      ></product-listing-filter-container>
      <product-listing-filter-chip-group
        class="mt-4"
        :items="filterItems"
        @click:remove="$emit('click:remove', $event)"
        @click:clear="$emit('click:clear', $event)"
      ></product-listing-filter-chip-group>

      <base-button
        large
        block
        rounded
        :loading="loading"
        class="mt-4 pink-berry white--text font-weight-bold"
        @click="internalValue = false"
        >{{ $t('commons.showProducts', { total: total }) }}
      </base-button>
    </div>
    <template #append>
      <base-button
        block
        large
        class="grey-lighten-3 text-capitalize"
        @click="internalValue = false"
      >
        <base-icon mdi="close" small class="mr-1"></base-icon>
        {{ $t('actions.close') }}
      </base-button>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { computed, onMounted, ref } from '@vue/composition-api'
import ProductListingFilterChipGroup from '~/components/product/listing/filter/ProductListingFilterChipGroup'
import ProductListingFilterContainer from '~/components/product/listing/filter/ProductListingFilterContainer'
import BaseIcon from '~/components/base/icon/BaseIcon'
import BaseButton from '~/components/base/button/BaseButton'

export default {
  name: 'ProductListingFilterDrawer',
  components: {
    BaseButton,
    BaseIcon,
    ProductListingFilterContainer,
    ProductListingFilterChipGroup,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loadingAggregations: {
      type: Boolean,
      default: false,
    },
    availableFilters: {
      type: Array,
      default: () => [],
    },
    filterValues: {
      type: Object,
      default: () => {},
    },
    filterItems: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    const booted = ref(false)

    const internalValue = computed({
      get() {
        return booted.value ? props.value : false
      },
      set(value) {
        emit('input', value)
      },
    })

    onMounted(() => {
      setTimeout(() => (booted.value = true), 5)
    })

    return {
      internalValue,
    }
  },
}
</script>
